var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelectBlog(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 421,
    height: 177,
    viewBox: "0 0 421 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M341.684 59.8255C330.669 64.1922 320.693 71.0425 310.84 77.5424C309.045 78.7264 307.25 79.9145 305.533 81.2088C304.988 81.6199 304.313 82.0058 304.071 82.6446C303.824 83.2998 305.326 83.2833 305.994 83.4907C311.363 85.1561 317.831 85.0804 323.301 84.0035C329.131 82.8557 334.264 79.2698 339.326 76.363C342.599 74.4831 344.757 72.7236 346.915 69.5942C347.848 68.2415 349.074 64.7417 347.799 63.1843C345.903 60.8663 341.554 59.1166 338.685 59.5948",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M317 74.0447C320.427 73.8147 323.711 73.089 327.025 72.1986C327.716 72.013 329.246 71.8425 329.692 71.0449C329.911 70.6527 329.939 70.2764 329.922 69.8398C329.843 67.7724 321.929 70.0179 320.923 71.2756",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M310.994 87.2856C313.311 92.5517 315.601 97.8286 317.865 103.118C320.006 108.12 322.457 113.158 324.07 118.373C324.465 119.65 324.339 120.976 325.814 120.976C328.3 120.976 331 121.271 333.454 120.809C335.538 120.417 337.416 119.107 339.3 118.207C344.602 115.674 350.792 114.878 355.478 111.105C356.68 110.137 357.289 109.213 357.863 107.81C358.273 106.809 358.991 105.93 358.991 104.81C358.991 102.421 359.047 100.086 358.542 97.7336C357.742 94.0002 355.934 90.8377 354.068 87.5548C351.56 83.1396 348.548 79.1296 346.761 74.3633",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M324.147 92.5938C326.649 98.6706 328.907 104.776 330.839 111.054",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M334.3 87.7461C336.591 93.5722 338.794 99.4227 340.992 105.283",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M342.146 84.9766C343.952 89.3969 345.755 93.8388 347.799 98.1552C348.097 98.7824 348.089 98.88 348.607 99.0526",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M267.151 78.5157C270.409 79.4421 271.806 80.2752 275.33 79.4131C278.553 78.6243 281.986 76.3118 284.483 74.2595C288.7 70.7939 291.737 66.1474 296.021 62.7474C298.811 60.5324 302.672 58.033 306.456 58.7733C308.272 59.1286 309.743 60.6322 311.097 61.7731C312.557 63.0034 314 64.2547 315.455 65.4908C315.934 65.8976 316.415 66.2252 316.763 66.7472",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M311.686 68.1316C313.126 68.9219 315.732 70.5123 317.455 69.4648C319.212 68.3971 319.532 64.683 319.532 62.8242",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M149.217 1C127.317 11.1737 106.236 18.7942 82.1094 21.222C81.2639 21.3071 67.6829 22.4951 69.1095 24.0719C73.6847 29.1286 77.3927 32.9463 80.3136 39.336C83.5319 46.3759 86.7951 53.3849 88.785 60.8853C90.4714 67.2415 92.6687 73.7181 93.5478 80.2485C94.9628 90.7605 94.4066 101.604 94.4066 112.182C94.4066 122.059 93.5454 132.422 94.8751 142.242C96.0004 150.552 97.7636 158.189 97.9201 166.68C97.9268 167.046 98.2763 178.55 99.7159 175.191C101.869 170.167 103.567 166.839 108.07 163.44C118.33 155.697 128.957 152.055 141.604 150.011C154.035 148.002 165.578 147.161 178.184 147.161C185.282 147.161 192.401 147.319 199.499 147.161C201.375 147.119 200.514 143.466 200.514 142.242",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M149.918 1C152.657 10.4621 157.826 18.8873 161.63 27.9367C166.452 39.4076 170.15 51.2317 175.762 62.3688C179.46 69.7091 181.266 77.9174 184.584 85.4797C187.91 93.0574 189.409 101.88 191.338 109.918C192.519 114.84 192.499 119.734 193.837 124.675C194.629 127.602 195.498 130.922 196.647 133.732C197.553 135.946 198.857 137.835 200.122 139.822C200.409 140.273 200.731 141.254 200.434 141.774C199.871 142.759 196.395 136.769 196.296 136.62",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M168.892 44.5662C169.713 33.5455 169.376 22.0596 168.541 11.032C168.47 10.0918 167.296 4.71753 168.814 4.12214C169.685 3.78072 173.03 3.81298 173.343 3.80984C179.028 3.7527 184.717 3.80984 190.402 3.80984C204.378 3.80984 218.354 3.80984 232.33 3.80984C239.039 3.80984 246.113 3.25003 252.825 3.96599C258.789 4.6021 259.421 5.54339 260.087 11.6956C260.627 16.6947 262.131 21.3849 262.702 26.4132C263.486 33.3135 263.053 40.4076 263.053 47.338C263.053 67.6641 263.053 87.9903 263.053 108.316C263.053 116.241 263.053 124.166 263.053 132.091C263.053 133.605 262.46 136.408 263.444 137.673C265.164 139.885 264.928 143.919 265.318 146.535C265.407 147.132 267.396 153.581 265.083 152.04C260.483 148.973 253.876 147.578 248.609 146.067C241.17 143.933 234.529 143.646 226.826 143.646C219.616 143.646 212.407 143.646 205.198 143.646C201.952 143.646 197.806 144.401 194.892 142.944",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.432 48.7852C101.699 52.8752 103.011 60.7311 108.069 60.7311C109.529 60.7311 113.378 60.8241 113.378 58.8963C113.378 54.527 111.843 50.6292 110.567 46.482C109.996 44.6249 100.421 47.9072 99.3239 48.7852",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M106.352 81.8091C123.755 76.8558 140.664 72.9814 158.664 71.1125C161.131 70.8564 164.341 70.8406 166.784 69.8633",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.055 99.3772C112.074 99.3772 117.204 98.4096 121.812 96.5664",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M121.108 137.321C134.459 133.13 147.256 132.402 161.162 132.402",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M180.837 25.5933C180.837 30.7464 180.837 35.8995 180.837 41.0526C180.837 41.817 180.404 44.7585 181.227 45.5811C182.433 46.7868 186.681 45.9715 188.215 45.9715C189.064 45.9715 193.106 46.6056 193.797 45.8153C195.607 43.7467 193.452 36.7285 193.173 34.5331C192.676 30.6271 193.493 25.9139 190.518 22.9386C189.517 21.9379 184.051 23.6345 182.945 24.1879",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M179.432 67.0547H246.891",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M183.648 80.4062C190.677 80.8517 197.702 81.3326 204.729 81.8116",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M193.485 119.051C209.52 119.051 227.164 117.078 242.674 121.159",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1 159.512C12.1236 156.908 22.0461 150.84 33.2393 148.303C42.3758 146.232 53.207 146.099 62.1493 148.858C69.7083 151.19 77.4557 154.843 85.2884 156.127C89.5992 156.833 94.0195 156.515 98.3838 156.515",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M420 149.527C399.73 144.277 379.055 136.46 357.963 135.654C347.267 135.246 335.779 134.582 325.169 136.098C319.869 136.855 314.885 139.385 309.632 139.927C303.567 140.552 297.369 139.433 291.32 140.315C283.381 141.473 275.728 141.536 267.682 141.536",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelectBlog);
export default __webpack_public_path__ + "static/media/delectBlog.704b71c77604c9a8b2659643d42c9dec.svg";
export { ForwardRef as ReactComponent };